import { useState } from 'react';
import styles from './styles.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft, faAngleRight } from '@fortawesome/free-solid-svg-icons';
import classNames from 'classnames';
import { addDays, addWeeks, format } from 'date-fns';

type RowProps = {
  nowDate: Date;
  changedDate: (value: Date) => void;
};
const OperatingRouteCalendar = ({ nowDate, changedDate }: RowProps) => {
  const [selectDay, setSelectDay] = useState<Date>(nowDate);
  const [firstDay, setFirstDay] = useState<Date>(new Date(nowDate.getTime()));
  const weekDate = (date: Date) => {
    const dateList = [];
    for (let i = 0; i < 7; i++) {
      dateList.push(addDays(new Date(date.getTime()), i));
    }
    return dateList;
  };
  const dates = weekDate(firstDay);

  const nextWeek = () => {
    const date = firstDay;
    const nextWeekDate = addWeeks(date, 1);
    setFirstDay(nextWeekDate);
  };

  const beforWeek = () => {
    const date = firstDay;
    const nextWeekDate = addWeeks(date, -1);
    setFirstDay(nextWeekDate);
  };

  const onSelect = (date: Date) => {
    if (selectDay.getFullYear() === date.getFullYear()) {
      if (selectDay.getMonth() === date.getMonth()) {
        if (selectDay.getDate() === date.getDate()) {
          return true;
        }
      }
    }
    return false;
  };

  const changeDate = (selectDate: Date) => {
    setSelectDay(selectDate);
    changedDate(selectDate);
  };

  const changeDateToToday = () => {
    setSelectDay(new Date());
    setFirstDay(new Date());
    changedDate(new Date());
  };

  return (
    <div className={styles.component}>
      <div className={styles.aboveText}>
        <button className={styles.today} onClick={() => changeDateToToday()}>
          今日
        </button>
        <div className={styles.selectMonth}>{format(firstDay, 'yyyy/M')}</div>
      </div>
      <div className={styles.underText}>
        <button onClick={() => beforWeek()} className={styles.leftIcon}>
          <FontAwesomeIcon icon={faAngleLeft} />
        </button>
        {dates.map((date) => (
          <button
            key={date.getDate()}
            className={classNames(
              styles.date,
              onSelect(date) && styles.onSelect
            )}
            onClick={() => changeDate(date)}
          >
            {date.getDate()}
          </button>
        ))}
        <button onClick={() => nextWeek()} className={styles.rightIcon}>
          <FontAwesomeIcon icon={faAngleRight} />
        </button>
      </div>
    </div>
  );
};

export default OperatingRouteCalendar;
